import axios from "axios";
import { getTaxCertificate,getTaxFilerDetails,getTaxNotifications } from "../endpoints";

export interface TaxCertificateParams {
  tax_type?: string[];
  status?: string[];
  business_channel?: string[];
  sales_area?: string[];
  sales_country?: string[];
  account_manager?: string[];
  cust_name?: string[];
  vessel_name?: string[];
  vessel_imo_number?: string[];
  port_name?: string[];
  region_name?: string[];
  country_name?: string[];
  cust_code?: string[];
  order_number?: string[];
  offSet: string;
}
interface notificationParams {
  offSet: string;
}
export const getTaxCertificateData = async (params: TaxCertificateParams,token:any) => {
  try {
    const requestBody = {
      offSet: params.offSet,
      ...Object.entries(params).reduce((acc, [key, value]) => {
        if (value && key !== 'offSet') {
          // Handle array values - keep as arrays
          if (Array.isArray(value) && value.length > 0) {
            acc[key] = value;
          } else if (!Array.isArray(value)) {
            acc[key] = value;
          }
        }
        return acc;
      }, {} as Record<string, any>),
    };

    const resp = await axios.post(`${getTaxCertificate}`, requestBody, {
      headers: {
        'Content-Type': 'application/json',
        Authorizationtoken: `Bearer ${token}`
      }
    });
    
    return resp.data;
  } catch (ex) {
    throw ex;
  }
};
export const getTaxcFilerDetails = async (token:any) => {
  try {
    const resp = await axios.get(`${getTaxFilerDetails}`, {
      headers: {
        //'x-api-key': 'gmedocumenthubtest.castrol.com',
        'Content-Type': 'application/json',
        Authorizationtoken: `Bearer ${token}`
      }
    });
    
    return resp.data;
  } catch (ex) {
    throw ex;
  }
};
export const getTaxNotification = async (params:notificationParams,token:any) => {
    try {
      const queryParams = new URLSearchParams();
    
    // Add required fields
    queryParams.append('offSet', params.offSet);
        const response = await axios.get(`${getTaxNotifications}?${queryParams.toString()}`, {
      headers: {
        //'x-api-key': 'gmedocumenthubtest.castrol.com',
        'Content-Type': 'application/json',
        Authorizationtoken: `Bearer ${token}`
      }
        }); 
        return response.data;
    } catch (error) {
        console.error('Error fetching tax notifications:', error);
        throw error;
    }
};